
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/payment",
      function () {
        return require("private-next-pages/accounts/payment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/payment"])
      });
    }
  